/**
 * Set once an applicant signs in, registers or confirms their email on this
 * browser, so a returning applicant opens the admissions page on Sign in while
 * a first-time visitor opens on Register. Blocked or cleared storage only
 * means the page opens on Register.
 */
const RETURNING_KEY = 'ilm.admissions.returning'

export const isReturningApplicant = (): boolean => {
  try {
    return localStorage.getItem(RETURNING_KEY) === '1'
  } catch {
    return false
  }
}

export const markReturningApplicant = () => {
  try {
    localStorage.setItem(RETURNING_KEY, '1')
  } catch {
    // private window or blocked storage: the next visit opens on Register
  }
}
